import * as $ from "jquery";

export default class Accordion {
  $domRoot: JQuery<HTMLElement>;
  params: any;
  $accordionHeading: any;
  $accordionContent: any;
  
  constructor(domRoot: HTMLElement, params: any) {
    this.$domRoot = $(domRoot);
    this.params = { ...params };

    this.$accordionHeading = this.$domRoot.find(".imkt-accordion--heading");
    this.$accordionContent = this.$domRoot.find(".imkt-accordion--content");

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    var self = this;

    this.$accordionHeading.on("click", function () {
      self.$domRoot.toggleClass("closed");
    });
  }
}
